<template>
  <div>
    <v-row v-if="!readonly">
      <v-col cols="12" sm="4" md="4" class="mt-0 pt-0">
        <UsersDropDownList
          label="Internal Employee"
          :userId="userId"
          :readonly="readonly"
          :isRequired="true"
          :securityRoles="[ADMIN, MANAGER, RECRUITER, SALES_PERSON]"
          @userIdChange="handleUserIdChange"
          @userNameChange="handleUserNameChange"
          @userRoleChange="handleUserRoleChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="mt-0 pt-0">
        <BusinessRolesDropDownList
          :businessRoles="role"
          :multiple="false"
          :readonly="readonly"
          @businessRolesChange="handleBusinessRoleChange"
        ></BusinessRolesDropDownList>
      </v-col>
      <v-col cols="8" sm="2" md="2" class="mt-0 pt-0">
        <FormattedNumberField
          label="Commission"
          :value="commission"
          append-icon="percent"
          :readonly="readonly"
          :error="!validCommissionPercentages"
          @valueChange="(newValue) => this.commission = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="4" sm="2" md="2" class="pt-0">
        <v-btn
          class="mx-1 my-1"
          color="red"
          outlined
          @click="removeCommission"
        >
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="readonly">
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <UsersDropDownList
          label="Employee"
          :userId="userId"
          :readonly="readonly"
          :isRequired="true"
          :securityRoles="[ADMIN, MANAGER, RECRUITER, SALES_PERSON]"
          @userIdChange="handleUserIdChange"
          @userNameChange="handleUserNameChange"
          @userRoleChange="handleUserRoleChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <BusinessRolesDropDownList
          :businessRoles="role"
          :multiple="false"
          :readonly="readonly"
          @businessRolesChange="handleBusinessRoleChange"
        ></BusinessRolesDropDownList>
      </v-col>
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <FormattedNumberField
          label="Commission"
          :value="commission"
          append-icon="percent"
          :readonly="readonly"
          @valueChange="(newValue) => this.commission = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { BusinessRolesDropDownList } from '@/components/securityRoles'
import UsersDropDownList from '@/components/users/UsersDropDownList.vue'
import { ADMIN, MANAGER, RECRUITER, SALES_PERSON } from '@/lib/constants/securityRoles'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    BusinessRolesDropDownList,
    UsersDropDownList,
    FormattedNumberField
  },
  props: [
    'commissionInput',
    'readonly',
    'validCommissionPercentages'
  ],
  data: () => ({
    isFormValid: false,
    ADMIN,
    MANAGER,
    RECRUITER,
    SALES_PERSON
  }),
  computed: {
    commissionInputValue: {
      get () {
        return this.commissionInput
      },
      set (newValue) {
        this.$emit('commissionRowChange', newValue)
      }
    },
    role: {
      get () {
        return this.commissionInput.role
      },
      set (newValue) {
        this.commissionInputValue.role = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
      }
    },
    userId: {
      get () {
        return this.commissionInput.userId
      },
      set (newValue) {
        this.commissionInputValue.userId = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
      }
    },
    commission: {
      get () {
        return this.commissionInput.commission
      },
      set (newValue) {
        this.commissionInputValue.commission = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
        this.$emit('commissionChange')
      }
    }
  },
  methods: {
    handleBusinessRoleChange (value) {
      this.role = value
    },
    handleUserIdChange (value) {
      this.userId = value
    },
    handleUserNameChange (firstName, lastName) {
      this.commissionInputValue.firstName = firstName
      this.commissionInputValue.lastName = lastName
    },
    handleUserRoleChange (securityRoles) {
      let role = securityRoles.find(role => role === 'RECRUITER' || role === 'SALES_PERSON')
      if (role) {
        this.role = role
      }
    },
    removeCommission () {
      this.$emit('remove', this.commissionInputValue.id)
    }
  }
}
</script>
